"use client";

import { m } from "framer-motion";

import SectionActionLink from "@/components/motion/SectionActionLink";
import TextReveal from "@/components/motion/TextReveal";

interface SectionHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  linkText?: React.ReactNode;
  href?: string;
}

export default function SectionHeader({ title, subtitle, linkText, href }: SectionHeaderProps) {
  return (
    <>
      <div className="mb-6 flex flex-col items-start justify-between gap-4 md:mb-12 md:flex-row md:items-end">
        <div>
          <div className="mb-4 text-5xl leading-none font-black tracking-tighter uppercase md:text-7xl">
            <TextReveal>{title}</TextReveal>
          </div>
          {subtitle && (
            <m.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 0.6,
                delay: 0.1,
                ease: [0.16, 1, 0.3, 1],
              }}
              className="text-muted-foreground max-w-md text-lg font-medium"
            >
              {subtitle}
            </m.p>
          )}
        </div>
        {href && linkText && (
          <m.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{
              duration: 0.6,
              delay: 0.2,
              ease: [0.16, 1, 0.3, 1],
            }}
            className="self-end"
          >
            <SectionActionLink href={href}>{linkText}</SectionActionLink>
          </m.div>
        )}
      </div>
      <div className="relative mb-6 md:mb-12">
        <m.div
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="bg-foreground h-1 w-full origin-left"
        />
        <m.div
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
          className="bg-muted-foreground/30 mt-1 h-0.5 w-full origin-left"
        />
      </div>
    </>
  );
}
